import { Row } from 'antd';
import { AccountStatusTag, MTypography } from 'src/lib';
import { AccountStatusLabel } from 'src/models';
import { BaseStyle, Spacing } from 'src/styles';

export const CurrentAccountStatus = ({ label }: { label: AccountStatusLabel }) => {
  return (
    <Row className={BaseStyle.level}>
      <MTypography variant='h5' weight='bold' className={Spacing.mr8}>
        Current Status
      </MTypography>
      <AccountStatusTag label={label} />
    </Row>
  );
};
